/**
 * Connects to EventBus to broadcast or subscribe to global events
 *
 */
import EventBus from "@/components/EventBus";
var CommMixin = {
  methods: {
    broadcast: function (id, data) {
      EventBus.$emit(id, data);
    },
    subscribe: function (id, callback = null) {
      EventBus.$on(id, (payload) => {
        if (callback !== null) callback(payload);
      });
    },
  },
};
export default CommMixin;
